export default {
  // 導航連結
  home: '首頁',
  features: '功能特色',
  about: '關於我們',
  contact: '聯絡我們',
  blog: '部落格',
  dashboard: '儀表板',
  settings: '設定',
  login: '登入',
  signup: '註冊',
  logout: '登出',
  supportUs: '支持我們',
  
  // 登出相關文字
  loggingOut: '正在登出...',
  redirectingToLogin: '正在重新導向至登入頁面...'
};